<template>
  <div class="ice-pay"></div>
</template>

<script>
import _wx from "../../static/js/chelun-wx-1.1.js";
import _kjz from "../../static/js/chelun-kjz.js";
import { cjjlPay, OPENIDNEW, baseUrl } from "../http/env.js";
import { pay, isShengPay } from "@/http/api";

// 常量定义
const MAX_PAY_RETRIES = 3;
const RETRY_DELAY_MS = 1000;
const CJJL_PAY_PATH = `${cjjlPay}/2017/superCoach/pay_wx.html`;

// 微信菜单配置
const HIDDEN_MENU_ITEMS = [
  "menuItem:share:appMessage",
  "menuItem:share:timeline",
  "menuItem:share:qq",
  "menuItem:share:weiboApp",
  "menuItem:favorite",
  "menuItem:share:facebook",
  "menuItem:share:QZone",
];

export default {
  name: "IceOutPayment",
  data() {
    return {
      openid: "",
      query: "",
      student_id: "",
      soft_sn: "",
      pay_order: {},
      pay_type: "",
      is_shengPay: 0,
      // 支付提交参数
      paySubmit: {
        c: "order",
        v: "pay2",
        serial_number: this.$route.query.serial_number || "",
        channel: "",
        callback_url: this.$route.query.callback_url
          ? decodeURIComponent(this.$route.query.callback_url)
          : "",
      },
    };
  },

  created() {
    // 隐藏菜单选项
    window["CHELUN_SHOW_OPTION_MENU"] = 0;
    _wx.hideMenus(HIDDEN_MENU_ITEMS);
  },
  mounted() {
    this.student_id = this.$route.query.student_id;
    this.soft_sn = this.$route.query.soft_sn;
    console.log(this.student_id, this.soft_sn);
    // 初始化支付流程
    this.initPaymentProcess();
  },

  methods: {
    /**
     * 初始化支付流程
     */
    async initPaymentProcess() {
      try {
        this.pay_type = sessionStorage.pay_type;

        // 1. 获取支付类型配置
        await this.fetchPaymentTypeConfig();

        // 2. 处理微信环境下的OpenID获取
        if (_wx.isWx && !this.handleWechatOpenId()) {
          return; // 如果需要重定向获取OpenID，结束当前流程
        }

        // 3. 设置支付渠道
        this.setPaymentChannel();

        // 4. 执行支付
        await this.executePayment();
      } catch (error) {
        console.error("支付流程初始化失败:", error);
        this.handlePaymentError(error);
      }
    },

    /**
     * 获取支付类型配置
     */
    async fetchPaymentTypeConfig() {
      try {
        const obj = {
          soft_sn: this.soft_sn,
          student_id: this.student_id,
        };

        const res = await isShengPay(obj);
        if (res.code === 0) {
          this.is_shengPay = res.data.is_shengPay;
          sessionStorage.setItem("is_shengPay", this.is_shengPay);
          console.log("支付类型配置获取成功:", this.is_shengPay);
        }
      } catch (error) {
        console.error("获取支付类型配置失败:", error);
        // 出错时默认使用标准支付
        this.is_shengPay = 0;
      }
    },

    /**
     * 处理微信环境下的OpenID
     * @returns {boolean} 是否可以继续支付流程
     */
    handleWechatOpenId() {
      this.paySubmit.openid = this.$route.query.openid || "";

      if (!this.paySubmit.openid) {
        console.log("微信OpenID不存在，需要重定向获取");
        this.redirectToGetOpenId();
        return false;
      }

      console.log("使用URL中的微信OpenID");
      return true;
    },

    /**
     * 重定向到获取OpenID的页面
     */
    redirectToGetOpenId() {
      const currentUrl = encodeURIComponent(window.location.href);
      let redirectUrl;

      if (this.is_shengPay === 1) {
        // 盛付通支付获取OpenID
        redirectUrl = `${baseUrl}/TYWxSDK/getOpenId?source=${currentUrl}`;
      } else {
        // 标准支付获取OpenID
        redirectUrl = `${OPENIDNEW}/xc_v1/Wechat/getOpenId?source=${currentUrl}`;
      }

      console.log("重定向到获取OpenID:", redirectUrl);
      window.location.href = redirectUrl;
    },

    /**
     * 设置支付渠道
     */
    setPaymentChannel() {
      if (this.is_shengPay === 1) {
        // 盛付通支付渠道
        this.paySubmit.channel = _wx.isWx ? "shengpay_mp" : "shengpay_ali";
      } else {
        // 标准支付渠道
        this.paySubmit.channel = _wx.isWx ? "weixin_mp" : "alipay";
      }

      console.log("设置支付渠道:", this.paySubmit.channel);
    },

    /**
     * 执行支付
     */
    async executePayment() {
      try {
        this.soft_sn = sessionStorage.soft_sn;
        const res = await pay({ ...this.paySubmit });

        if (_wx.isWx) {
          // 微信环境下的支付逻辑
          this.handleWechatPayment(res);
        } else {
          // 非微信环境下的支付逻辑
          this.handleNonWechatPayment(res);
        }
      } catch (error) {
        console.error("支付请求失败:", error);
        this.handlePaymentError(error);
      }
    },

    /**
     * 处理微信环境下的支付
     */
    handleWechatPayment(response) {
      // 处理特殊来源的支付
      if (this.$route.query.payFrom) {
        this.handleSpecialSourcePayment(response);
        return;
      }

      // 普通微信支付，带重试机制
      this.initiateWechatPaymentWithRetry(response);
    },

    /**
     * 处理特殊来源的支付
     */
    handleSpecialSourcePayment(response) {
      const orderParams = response.data.order_param;
      if (!orderParams) {
        console.error("订单参数不存在");
        return;
      }

      // 构建URL参数
      const urlParams = Object.entries(orderParams)
        .map(([key, value]) => `&${key}=${value}`)
        .join("");

      const redirectUrl = CJJL_PAY_PATH + urlParams.replace(/^&/, "?");
      console.log("跳转到特殊来源支付页面:", redirectUrl);
      window.location.href = redirectUrl;
    },

    /**
     * 初始化带重试机制的微信支付
     */
    initiateWechatPaymentWithRetry(response) {
      let retryCount = 0;

      const wxPay = () => {
        // 根据支付类型选择参数
        const payParams =
          this.is_shengPay === 1
            ? response.data.payInfo
            : response.data.order_param;

        // 确保payParams存在
        if (!payParams) {
          console.error("支付参数不存在");
          this.handlePaymentError(new Error("支付参数获取失败"));
          return;
        }

        _wx.pay(
          payParams,
          // 成功回调
          () => {
            const successRedirectUrl =
              this.is_shengPay === 1
                ? this.paySubmit.callback_url
                : response.data.order_param.callback_url;
            console.log("支付成功，跳转到:", successRedirectUrl);
            window.location.href = successRedirectUrl;
          },
          // 失败回调
          (err) => {
            console.error(
              `微信支付调起失败 (${retryCount + 1}/${MAX_PAY_RETRIES}):`,
              err
            );

            if (retryCount < MAX_PAY_RETRIES) {
              // 重试支付
              retryCount++;
              console.log(
                `第${retryCount}次重试微信支付，等待${RETRY_DELAY_MS}ms`
              );
              setTimeout(wxPay, RETRY_DELAY_MS);
            } else {
              // 重试失败，使用备用支付方案
              this.fallbackToAlternativePayment(response);
            }
          }
        );
      };

      // 开始支付尝试
      console.log("开始微信支付流程");
      wxPay();
    },

    /**
     * 回退到备用支付方案
     */
    fallbackToAlternativePayment(response) {
      console.log("微信支付重试失败，使用备用支付方案");

      if (!response.data.order_param) {
        console.error("备用支付参数不存在");
        this.handlePaymentError(new Error("备用支付参数获取失败"));
        return;
      }

      // 构建备用支付URL
      const backupUrl = Object.entries(response.data.order_param)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      const redirectUrl = `${CJJL_PAY_PATH}?${backupUrl}`;
      console.log("跳转到备用支付页面:", redirectUrl);
      window.location.href = redirectUrl;
    },

    /**
     * 处理非微信环境下的支付
     */
    handleNonWechatPayment(response) {
      let redirectUrl;

      if (this.is_shengPay === 1) {
        redirectUrl = response.data.payInfo;
      } else {
        redirectUrl = response.data.url;
      }

      if (!redirectUrl) {
        console.error("非微信支付URL不存在");
        this.handlePaymentError(new Error("支付链接获取失败"));
        return;
      }

      console.log("非微信环境，跳转到支付页面:", redirectUrl);
      window.location.href = redirectUrl;
    },

    /**
     * 处理支付错误
     */
    handlePaymentError(error) {
      // 这里可以根据实际需求添加更友好的错误提示和处理
      console.error("支付错误处理:", error);

      // 例如：显示错误提示或跳转到错误页面
      // alert(`支付处理失败: ${error.message || '未知错误'}`);
      // 或者跳转到失败页面
      // window.location.href = `${hostUrl}/payment/failed?reason=${encodeURIComponent(error.message || '未知错误')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.ice-pay {
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ice-out.vue